import React, { ReactElement } from 'react';

import { THeadingColor } from 'components/Heading/Heading.types';
import CircleCheckIcon from 'components/Icons/CircleCheckIcon';
import CircleErrorIcon from 'components/Icons/CircleErrorIcon';
import { Icon } from '../Icon';

export const STATUS_TYPES = {
  success: 'success',
  error: 'error',
  info: 'info',
} as const;

export const TEXT_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const STATUS_CONTENT_TYPE: {
  [key: string]: {
    headingColor: THeadingColor;
    icon: ReactElement;
  };
} = {
  [STATUS_TYPES.error]: {
    headingColor: 'danger',
    icon: <CircleErrorIcon />,
  },
  [STATUS_TYPES.success]: {
    headingColor: 'success',
    icon: <CircleCheckIcon />,
  },
  [STATUS_TYPES.info]: {
    headingColor: 'primary',
    icon: <Icon name="basket-active" size={40} />,
  },
};
